var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-list-view"},_vm._l((_vm.options),function(opt,i){return _c('div',{key:i,staticClass:"item"},[_vm._v("\n\t\t\t"+_vm._s(opt.label)+"\n\t\t\t"),_c('switch-view',{attrs:{"value":_vm.value.includes(opt.value)},on:{"input":function($event){return _vm.switchInput(opt.value, $event)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }